import React from 'react'
import { ToastContainer } from 'react-toastify'
import './styles/purchase-new.css'
import Purchase from './components/Purchase'

/*
import {QueryClient, QueryClientProvider} from '@tanstack/react-query'
import { PurchaseProvider } from './contexts/PurchaseContext'
*/

import { PurchaseProviderNew } from './contexts/PurchaseContextNew'

const params = new URLSearchParams(window.location.search);
const product = params.get('product');
const defaultType = params.get('purchase-options');
const host = params.get('host');
const singleStr = params.get('single');
const single = singleStr == '1';

const message = params.get('message');
const sessionId = params.get('session')

export default function App({source}) {
    const useDeeplinks = source !== 'hub'

    return (
        <>
        <PurchaseProviderNew useDeeplinks={useDeeplinks} collection={product} defaultHost={host} defaultType={defaultType}>
            <Purchase
                isHub={source == 'hub'}
                isSingleProduct={single}
                onComplete={() => {}}
                />
        </PurchaseProviderNew>
        <ToastContainer />
        </>
    )
}
    